import type {FieldReturn} from '../types'

export const group = (name: string, fields: FieldReturn[] = []): FieldReturn[] =>
  fields.map((field) => ({...field, group: name}))
